/* global crb_app */
import mapboxgl, { Map, NavigationControl } from 'mapbox-gl';

class MapboxWrapper {
  constructor(mapElement) {
    mapboxgl.accessToken = crb_app.mapbox_token;
    this.mapElement = mapElement;
    this.initMap();
  }

  /**
   * Initialise the map
   */
  initMap() {
    let longitude = parseFloat(this.mapElement.getAttribute('data-longitude'));
    let latitude = parseFloat(this.mapElement.getAttribute('data-latitude'));
    let radius = parseInt(this.mapElement.getAttribute('data-radius')) || 2000;
    let zoom = parseFloat(this.mapElement.getAttribute('data-mapzoom')) || 13;

    if (typeof longitude === 'undefined' || !longitude || typeof latitude === 'undefined' || !latitude) {
      longitude = -62.831448;
      latitude = 17.903496;
    }

    if (document.body.classList.contains("single-villa")) {
      this.map = new Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/dark-v10',
        center: [longitude, latitude],
        zoom: zoom,
      });
      this.map.addControl(new NavigationControl());
    }

    this.map.on('load', async () => {
      const geojson = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [longitude, latitude],
            },
          }],
      };

      this.map.addSource('area', {
        type: 'geojson',
        data: geojson,
      });

      this.map.addLayer({
        id: 'villa',
        type: 'circle',
        source: 'area',
        paint: {
          'circle-color': '#93A09C',
          'circle-stroke-color': '#0B4134',
          'circle-stroke-width': 1,
          'circle-opacity': 0.5,
          'circle-radius': {
            stops: [
              [0, 0],
              [25, metersToPixelsAtMaxZoom(radius, geojson.features[0].geometry.coordinates[0])],
            ],
            base: 1.75,
          },

        },
      });
    });
  }
}

const metersToPixelsAtMaxZoom = (meters, latitude) => {
  return meters / 0.075 / Math.cos(latitude * Math.PI / 180);
};

document.addEventListener('DOMContentLoaded', function () {
  const map = document.querySelector('#map');
  if (!map) {
    return;
  }
  new MapboxWrapper(map);
});
